import React, { createContext, useEffect, useState } from "react";
import { getSortedCollection } from "sprint-common-web";

import { GetDeliveryEndpointsLookupResponse } from "../../api/orders-api/delivery-endpoint/GetDeliveryEndpointsLookupResponse";
import { useDeliveryEndpointApi } from "../../api/orders-api/delivery-endpoint/useDeliveryEndpointApi";
import { DeliveryEndpoint, mapToDeliveryEndpoint } from "../../types/DeliveryEndpoint";

interface IDeliveryEndpointsDataContext {
    deliveryEndpoints: DeliveryEndpoint[];
    isLoading: boolean;
}

export const DeliveryEndpointsDataContext = createContext<IDeliveryEndpointsDataContext>({
    deliveryEndpoints: [],
    isLoading: true
});

export const DeliveryEndpointsDataProvider: React.FC = ({ children }) => {
    const [deliveryEndpoints, setDeliveryEndpoints] = useState<DeliveryEndpoint[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const { getDeliveryEndpointsLookup } = useDeliveryEndpointApi();

    useEffect(() => {
        setIsLoading(true);
        getDeliveryEndpointsLookup()
            .then((response: GetDeliveryEndpointsLookupResponse) => {
                const newItems = response.items.filter((item) => !!item).map(mapToDeliveryEndpoint);
                const sortedItems = getSortedCollection(newItems, "name");

                setDeliveryEndpoints(sortedItems);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    return (
        <DeliveryEndpointsDataContext.Provider value={{ deliveryEndpoints, isLoading }}>
            {children}
        </DeliveryEndpointsDataContext.Provider>
    );
};
